export const WinAPI = (apiName, params, callback) => {
  if (window.API) {
    console.log($t("a715bb174b"), JSON.stringify({
      name: apiName,
      params
    }));
    try {
      window.API.use({
        method: apiName,
        data: params,
        success: callback
      });
    } catch (e) {
      console.error($t("bfe4bd3c5e"));
    }
  } else {
    console.log($t("6d596f3e1b"), JSON.stringify({
      name: apiName,
      apiName
    }));
  }
};

// 埋点
export const TaLog = function (param) {
  if (typeof window.TA != 'undefined' && param.id) {
    console.log($t("f93d7233ea"), param);
    param._sid = Date.now() + Math.random();
    window.TA.log(param);
  } else {
    console.log($t("7b317dc923"), param);
  }
};
export const dateformatter = function (date, fmt) {
  if (!date || !(date instanceof Date)) return '';
  const o = {
    'M+': date.getMonth() + 1,
    'd+': date.getDate(),
    'h+': date.getHours(),
    'm+': date.getMinutes(),
    's+': date.getSeconds(),
    'q+': Math.floor((date.getMonth + 3) / 3),
    // 季度
    'S+': date.getMilliseconds() // 毫秒
  };

  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substring(4 - RegExp.$1.length));
  }
  for (let k in o) {
    if (new RegExp('(' + k + ')').test(fmt)) {
      fmt = fmt.replace(RegExp.$1, RegExp.$1.length === 1 ? o[k] : ('00' + o[k]).substring(('' + o[k]).length));
    }
  }
  return fmt;
};
export const getUrlParam = url => {
  var index = url.lastIndexOf('?v=') > -1 ? url.lastIndexOf('?') : url.indexOf('?');
  var arr1 = url.substr(index + 1).split('&');
  var arr2 = [];
  var obj = {};
  for (var i = 0; i < arr1.length; i++) {
    let index = arr1[i].indexOf('=');
    arr2[0] = arr1[i].slice(0, index);
    arr2[1] = arr1[i].slice(index + 1);
    obj[arr2[0]] = arr2[1];
  }
  return obj;
};
export const downloadBase64File = function (data, filename, type) {
  const url = data;
  const link = document.createElement('a');
  link.style.display = 'none';
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};